import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import Button from '@components/Button';
import FormErrors from '@components/FormErrors';
import { CheckBoxField, TextField } from '@components/FormFields';
import { useTeamUpdate } from '@hooks';
import { Team } from '@utils/backend-api/teams';

import SettingsHeading from '../SettingsHeading';

const EMAIL_DOMAIN_REGEX = /^((?:https?:\/\/)?[^./]+(?:\.[^./]+)+(?:\/.*)?)$/;

const validationSchema = () =>
  Yup.object({
    emailDomain: Yup.string().matches(EMAIL_DOMAIN_REGEX, 'Please enter a valid domain').nullable(),
  });

export default function EmailDomainForm({ team }: { team: Team }) {
  const { updateTeamAsync, updateTeamData } = useTeamUpdate();

  const initialValues = {
    emailDomain: team?.email_domain?.replace('@', '0') || '',
    addByDomain: !!team?.email_domain,
  };

  return (
    <div data-test="team-settings-domain">
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) =>
          updateTeamAsync({
            email_domain: values.emailDomain,
          })
        }
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {({ isSubmitting, values }) => (
          <Form>
            <SettingsHeading title="Add By Corporate Domain">
              <div className="flex items-center">
                <CheckBoxField name="addByDomain" />
                Allow anyone on my team that signs in with their corporate email to subscribe to The
                Information on my account. Each additional team member will be charged at an annual
                cost of $399 per year.
              </div>
            </SettingsHeading>
            {values.addByDomain && (
              <>
                <TextField
                  name="emailDomain"
                  placeholder="Enter a corporate domain (e.g. example.com)"
                />
                {!!updateTeamData?.errors && <FormErrors errors={updateTeamData.errors} />}
                <Button variant="primary" className="mt2" type="submit" disabled={isSubmitting}>
                  Save
                </Button>
              </>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}
